/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Frail_Halibut_CherishInputs */

const fr_teal_frail_halibut_cherish = /** @type {(inputs: Teal_Frail_Halibut_CherishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date du cours`)
};

/**

* @param {Teal_Frail_Halibut_CherishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teal_frail_halibut_cherish = /** @type {((inputs?: Teal_Frail_Halibut_CherishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Frail_Halibut_CherishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teal_frail_halibut_cherish(inputs)
});